import {
  Anchor,
  Button,
  Container,
  Paper,
  Text,
  TextInput,
  Title,
} from "@mantine/core";
import React, { useState } from "react";

import { trpc } from "../trpc/TrpcReactQueryProvider";
import { navigate } from "vike/client/router"
import { tenantConf } from "../../conf";
import { useQueryClient } from "@tanstack/react-query";
export default function AppLogin() {
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false)
  const queryClient = useQueryClient();
  queryClient.clear();
  const loginRequest = trpc.auth.loginRequest.useMutation();
  const loginCode = trpc.auth.loginCode.useMutation();
  // const navigate = useNavigate();

  // useEffect(() => {
  //   if (step === "redirect") {
  //     return navigate(`/app/list`);
  //   }
  // }, [step]);

  const handleSteps = async (evt: React.SyntheticEvent) => {
    evt.preventDefault();
    setButtonDisabled(true)
    setErrorMsg("");
    if (step === "email") {
      const username = (email.includes('@') ? email.substring(0, email.indexOf("@")) : email).trim().toUpperCase();
      if (username.length < 2 || username.length > 50) {
        setErrorMsg("Eingabe ungültig!")
        setButtonDisabled(false)
        return
      }
      try {
        const result = await loginRequest.mutateAsync({ username });

        setStep("code");

      } catch (error) {
        const userError = error?.message?.split('PUBLIC:')?.[1] ?? "Eingabe ungültig!"
        setErrorMsg(userError)
      } finally {
        setButtonDisabled(false)
      }
    } else if (step === "code") {
      const username = (email.includes('@') ? email.substring(0, email.indexOf("@")) : email).trim().toUpperCase();
      const codeKnz = code.trim()
      const params = new URLSearchParams(window.location.search)
      const redirectParam = params.get('redirect') ?? ''
      const redirect = ['/leads', '/settings', '/exports'].includes(redirectParam) ? redirectParam : '/leads'
      try {
        if (window.location.hostname === 'localhost') {
          setButtonDisabled(true)
          await loginCode.mutateAsync({ code: codeKnz, username })
          navigate(redirect);
        } else {
          const result = await fetch(`/cfix/code`, {
            method: 'POST',
            body: JSON.stringify({ code: codeKnz, username }),
          })
          const body = await result.text()
          if (body === "") {
            navigate(redirect);
          } else {
            setButtonDisabled(false)
            setCode("")
            if (body === "ERROR 002") {
              setStep("email")
            }
            throw new Error("Code falsch!")
          }
        }


      } catch (error) {
        window.alert("Code falsch!")
        setButtonDisabled(false)
        setCode("")
      }
    };
  }
  const handleChange = (evt: {
    target: { value: React.SetStateAction<string> };
  }) => {
    if (step === "email") {
      setEmail(evt.target.value);
    } else {
      setCode(evt.target.value);
    }
  };

  const username = (email.includes('@') ? email.substring(0, email.indexOf("@")) : email).trim().toUpperCase();
  const emailDisplay = `<${username.split('*')[0].toLowerCase()}@${tenantConf?.EmailDomain ?? ''}>`
  return (
    <Container size={420} my={40}>
      <Title align="center">__('Anmeldung')</Title>
      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <form onSubmit={(evt) => handleSteps(evt)}>
          <TextInput
            label={step === "email" ? "__('Ihre Anmeldekennung')" : "__('Code eingeben')"}
            value={step === "email" ? email : code}
            onChange={handleChange}
          />
          {step === "code" && (
            <Text weight="300" size="sm">
              __('Der Code wurde an') <b>{emailDisplay}</b> __('gesendet.'){" "}
              <Anchor onClick={() => setStep("email")}>
                __('E-Mail korrigieren.')
              </Anchor>
            </Text>
          )}
          {errorMsg && <Text color="red" weight="bold" fz="sm">
            __('Fehler'): {errorMsg}
          </Text>}
          <Button
            type="submit"
            fullWidth
            mt="xl"
            onClick={(evt: React.SyntheticEvent<Element, Event>) => handleSteps(evt)}
            loading={buttonDisabled}
          >
            {step === "email" ? "__('Code anfordern')" : "__('Anmelden')"}
          </Button>
        </form>
      </Paper>
    </Container>
  );
}

